angular.module('app.directives').directive('vpLoading', () => ({
    restrict: 'EA',

    scope: {
        model: '=',
        elementSelector: '@',
        addClass: '@?',
    },

    controller($window, $rootScope, $scope, $timeout, $filter) {
        $scope.show = true;
        $scope.element = null;

        if ($scope.elementSelector) {
            $scope.element = angular.element($scope.elementSelector);
        }

        $scope.$watch('show', (newValue, oldValue) => {
            if (newValue) {
                $rootScope.content_preloader_show();
                $scope.element && $scope.element.hide();
                $timeout(() => {
                    $(window).trigger('resize');
                }, 500);
            } else {
                $rootScope.content_preloader_hide();
                $scope.element && $scope.element.show();
                $timeout(() => {
                    $(window).trigger('resize');
                }, 500);
            }
        });

        if ('object' === typeof $scope.model && $scope.model.then) {
            $scope.model.then(() => {
                $scope.show = false;
            });
        } else {
            $scope.$watch(
                () => $filter('count')($scope.model),
                (newValue, oldValue) => {
                    $timeout(() => {
                        $scope.show = 0 < newValue ? false : true;
                    }, 750);
                }
            );
        }
    },
}));
